import { Component } from '@angular/core';
import { BackButtonComponent } from 'app/common/components/back-button/back-button.component';
import { ChipComponent } from 'app/common/components/chip/chip.component';
import { ContentCardComponent } from 'app/common/components/content-card/content-card.component';
import { LinksComponent } from 'app/common/components/links/links.component';
import { AboutVolkstheaterComponent } from './components/about-volkstheater/about-volkstheater.component';
import { FooterComponent } from 'app/footer/footer.component';

@Component({
  selector: 'app-volkstheater',
  templateUrl: './volkstheater.component.html',
  styleUrls: ['./volkstheater.component.less'],
  imports: [
    ContentCardComponent,
    BackButtonComponent,
    ChipComponent,
    LinksComponent,
    AboutVolkstheaterComponent,
    FooterComponent,
  ],
})
export class VolkstheaterComponent {
  Instagram = 'https://www.instagram.com/neuburgervolkstheater/';
  Facebook = 'https://www.facebook.com/VolkstheaterNeuburg';
  Web = 'https://neuburger-volkstheater.de';
  Color = '#A13333';

  chips = ['Wordpress', 'SEO', 'Design', 'Kulturerbe', 'Volkstheater'];
}